import { YubinBango } from '../vendor/yubinbango'

document.addEventListener('turbo:load', () => {
  const postalCode = document.querySelector<HTMLInputElement>('.p-postal-code')
  if (postalCode === null) return

  /* eslint-disable no-new */
  new YubinBango.MicroformatDom()
  /* eslint-enable no-new */
})
